import * as React from 'react';
import { observer } from 'mobx-react';

import { ZuluIcon } from 'src/app/shared/icon';

interface CardControllerProps {
	mode: ControlMode;
	title?: string;
	icon?: string;
	className?: string;
}

@observer
export class CardController extends React.Component<CardControllerProps, {}> {
	constructor(props: Readonly<CardControllerProps>) {
		super(props);
	}

	private renderChildren(props) {
		return React.Children.map(this.props.children, child => {
			if(child != null)
				return React.cloneElement(child as any, {
					mode: props.mode
				})

			return child;
		})
	}

	render() {
		return (
			<div className={`card ${this.props.className || ''}`}>
				<h2>
					{this.props.icon && <ZuluIcon type={this.props.icon} />}  {this.props.title}
				</h2>
				{this.renderChildren({ mode: this.props.mode })}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/card.controller.tsx